import { Link } from 'react-router-dom';

const features = [
  { icon: 'ri-line-chart-line', title: '权威行情数据', desc: '覆盖现货、期货等多品种，结构化展示开高低收与成交量。' },
  { icon: 'ri-article-line', title: '深度市场分析', desc: '每日更新市场观点与投资策略，帮助你理解金价运行逻辑。' },
  { icon: 'ri-shield-star-line', title: '专业可信内容', desc: '聚焦黄金投资场景，内容严谨、来源清晰、持续更新。' },
];

export default function SiteIntro() {
  return (
    <section className="bg-secondary-900">
      <div className="mx-auto max-w-portal px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-primary-400">About Us</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              专业、及时、易用的黄金投资信息平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200 md:text-base">
              「黄金」聚焦黄金价格行情、市场分析与投资资讯，面向关注贵金属投资的个人投资者与财经研究人员，
              提供权威、及时的行情数据与深入的投资指导内容，帮助你科学把握黄金投资机会。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400 whitespace-nowrap"
              >
                了解我们
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <Link
                to="/category/gold-price"
                className="inline-flex items-center gap-1.5 rounded-md border border-secondary-600 px-5 py-2.5 text-sm font-medium text-background-100 transition-colors hover:border-primary-400 hover:text-primary-300 whitespace-nowrap"
              >
                浏览行情
              </Link>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.title} className="rounded-lg border border-secondary-700 bg-secondary-800 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-xl text-primary-400">
                  <i className={feature.icon} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-background-50">{feature.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-secondary-300">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}